// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserMgrOutlinedSvg from "@fishx/icons-svg/es/asn/UserMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var UserMgrOutlined = function UserMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserMgrOutlinedSvg
  }));
};

UserMgrOutlined.displayName = 'UserMgrOutlined';
export default React.forwardRef(UserMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserMgrOutlined.js
// module id = 4350
// module chunks = 0